import React from 'react';

export default function ContentWrapper(props) {
    return (
        <div className="c_8_2" data-columns={props.columns}>
            {props.children}
        </div>
    );
}
